import { Singleton } from "@denishussar/html5-game-engine";
import { engineButtons } from "../../Controllers/MiniGames/EngineGame/EngineButtonController";


@Singleton
export class EnginePowerUpModel {
    public btnStates: number[];
    public showDialog: boolean;
    constructor(){
        this.btnStates = new Array(12).fill(0,0,10);
        this.showDialog = false;
    }

    public clear(){
        this.btnStates = new Array(12).fill(0,0,10);
        this.showDialog = false;
    }
}
